import { getAllDriversRoutesAsync } from "../../store/features/driversRoutes/driversRoutesThunk";
import { selectOrderById } from "../../store/features/orders/orderSelectors";
import { getActiveOrdersAsyncThunk } from "../../store/features/orders/ordersThunk";
import AccordionSummary from "../Accordion/AccordionSummary";
import OrderCard from "../Orders/OrderCard";
import DriversMap from "./DriversMap";
// import { IFilterState } from "../../Map";
import { selectAllDrivers } from "@App/modules/Logistics/store/features/drivers/driverSelectors";
import { useConfirmationDialog } from "@shared/context/ConfirmationDialogContext";

import {
  Accordion,
  AccordionDetails,
  Avatar,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemIcon,
  ListItemText,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { grey } from "@material-ui/core/colors";
import { Storefront } from "@material-ui/icons";
import DragHandleIcon from "@material-ui/icons/DragHandle";
import ColoredButton from "@shared/components/ColoredButton/ColoredButton";
import DialogTitle from "@shared/components/Dialog/DialogTitle";
import { IMapDriver, IMapOrder } from "@shared/components/Map/models/models";
import { useMemoSelector } from "@shared/hooks";
import { getDriverActiveRoute, updateDriverRoute } from "@shared/services/drivers/drivers.service";
import { IRoutePointDto } from "@shared/services/orders/dtos/orders/routePointDto";
import { IShortRoutePointDto } from "@shared/services/orders/dtos/orders/shortRoutePointDto";
import {
  IRoutePoint,
  getDriverAndOrderRoutePoints,
  modifyDriverRoutePoints,
  generateGroupOrdersAsync,
  groupOrdersAsync,
  PackageOrderGuid,
  IFullOrderDto,
} from "@shared/services/order.service";
import clsx from "clsx";
import dayjs from "dayjs";
import { useSnackbar } from "notistack";
import { FC, useEffect, useState } from "react";
import { DragDropContext, Draggable, DropResult, Droppable } from "react-beautiful-dnd";
import { useDispatch } from "react-redux";
import { ShortRoutePoint, IOrderDto, getOrderDetailsAsync } from "@shared/services/order.service";
import GeneratePackageMap from "./GeneratePackageMap";
import { IPackageOrderGuidDto } from "@shared/services/orders/dtos/orders/packageOrderGuidDto";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginTop: 10,
  },
  container: {
    height: "75vh",
  },
  dialogContent: {
    padding: "18px 24px 8px 24px",
    height: "600px",
  },
  avatar: {
    objectFit: "contain",
  },
  listItem: {
    backgroundColor: theme.palette.background.paper,
    border: `1px dashed ${theme.palette.secondary.main}`,
    marginTop: "-2px",
  },
  disabled: {
    backgroundColor: grey[300],
  },
}));

const draggingCustomStyle = (style: React.CSSProperties | undefined) => {
  if (style.transform) {
    const axisLockY =
      "translate(0px" + style.transform.slice(style.transform.indexOf(","), style.transform.length);

    return {
      ...style,
      transform: axisLockY,
    };
  }
  return style;
};

export interface GeneratePackageDialogProps {
  orderId1: number;
  orderId2?: number;
  onClose?: () => void;
}

const GeneratePackageDialog: FC<GeneratePackageDialogProps> = ({ orderId1, orderId2, onClose }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [driverRoutePoints, setDriverRoutePoints] = useState<IShortRoutePointDto[]>([]);
  const [orders, setOrders] = useState<IPackageOrderGuidDto[]>([]);
  const [ordersObjects, setOrderObjects] = useState<IOrderDto[]>([]);

  const order1 = useMemoSelector((state) => selectOrderById(state, orderId1));
  const order2 = useMemoSelector((state) => selectOrderById(state, orderId2));

  const packageOrders: IFullOrderDto[] = [order1, order2];
  const confirmationDialog = useConfirmationDialog();

  useEffect(() => {

    const fn = async () => {

      const response = await generateGroupOrdersAsync(orderId1, orderId2)

      const response2 = await getOrderDetailsAsync(orderId1.toString())
      const response3 = await getOrderDetailsAsync(orderId2.toString())
      const order1 = response2;
      const order2 = response3;
      const ordersObjectsL: IOrderDto[] = [order1, order2];

          const routePoints = response.routePoints;
          const routePoints2 = routePoints.map(
            (routePoint) => {
              const order = ordersObjectsL.find((o) => {
                
                return o.id === routePoint.orderId;
              });
              
              return { ...routePoint, order: order };
            }
          );

          setOrderObjects(ordersObjectsL);
          setDriverRoutePoints(routePoints2);
          setOrders(response.orders.map((x) => ({
            ...x,
            packageGuid: response.packageGuid,
            displayOrderNumber: x.externalOrderNumber,
          })));

      // ({...routePoint, order: ordersObjectsL.find(x => x.id === routePoint.orderId)})
    }
    fn();
    // generateGroupOrdersAsync(orderId1, orderId2).then((response) => {
      

    //   getOrderDetailsAsync(orderId1.toString()).then((response2) => {
    //     order1 = response2;
    //     ordersObjectsL.push(order1);
    //     getOrderDetailsAsync(orderId2.toString()).then((response3) => {
    //       order2 = response3;
    //       ordersObjectsL.push(order2);

          
    //       
    //     });
    //   });
    // });
  }, [orderId1, orderId2]);

  const handleDragEnd = (result: DropResult) => {
    const { source, destination } = result;

    if (!destination) {
      return;
    }

    if (destination.index === source.index) {
      return;
    }

    const old_index = source.index;
    const new_index = destination.index;


    const _points = [...driverRoutePoints];

    const [el] = _points.splice(old_index, 1);
    _points.splice(new_index, 0, el);

    setDriverRoutePoints(_points);
  };

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const handleSubmit = () => {
    const routePoints = driverRoutePoints;
    const packagePost = {
      PackageGuid: orders[0].packageGuid,
      orders: orders,
      routePoints: routePoints,
    };
    const promise = groupOrdersAsync(packagePost);
    promise
      .then(() => {
        // Show snackbar
        enqueueSnackbar("Рутата е успешно зачувана.", {
          variant: "success",
          autoHideDuration: 6000,
        });
        // Promise.all([dispatch(getActiveOrdersAsyncThunk()), dispatch(getAllDriversRoutesAsync())]);
        onClose?.();
      })
      .catch((error) => {
        // TODO: Change this to show an error message
        enqueueSnackbar(`Грешка: ${error.message}`, {
          variant: "error",
          persist: true,
          preventDuplicate: true,
          anchorOrigin: { horizontal: "left", vertical: "bottom" },
          action: function onDismiss(key) {
            return <Button onClick={() => closeSnackbar(key)}>OK</Button>;
          },
        });

        onClose?.();
      });
  };

  return (
    <Dialog open fullWidth maxWidth="xl" onClose={onClose}>
      <DialogTitle onClose={onClose}>
        {orderId2 !== null ? "Групирај нарачки" : "Промени рута"}
      </DialogTitle>

      <Divider />

      <DialogContent className={classes.dialogContent}>
        {
          <Grid style={{ height: "100%" }} container>
             <Grid xs={8} style={{ height: "100%" }} item>
              <GeneratePackageMap
                ordersI={ordersObjects}
                routePointsI={driverRoutePoints}
              />
            </Grid>
            <Grid xs={4} item>
              <DragDropContext onDragEnd={handleDragEnd}>
                <Droppable droppableId="driver-route-points">
                  {(provided) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.droppableProps}
                      style={{ height: "100%" }}
                    >
                      {driverRoutePoints.map((routePoint, index) => (
                        <Draggable
                          key={routePoint.orderId.toString() + routePoint.isPickup.toString()}
                          draggableId={
                            routePoint.orderId.toString() + routePoint.isPickup.toString()
                          }
                          index={index}
                          isDragDisabled={Boolean(false)}
                        >
                          {(provided) => (
                            <ListItem
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              style={draggingCustomStyle(provided.draggableProps.style)}
                            >
                              {/* <ListItemText
                                primary={
                                  routePoint.isPickup
                                    ? `PU:`
                                    : `DO:`
                                }
                              /> */}
                              <OrderCard pickup={routePoint.isPickup ? "PU" : "DO"} order={routePoint.order} />
                                                         <Typography
                                variant="body1"
                                style={{
                                  marginRight: "1rem",
                                  fontWeight: "bold",
                                }}
                              ></Typography>

                              <ListItemIcon>
                                <DragHandleIcon />
                              </ListItemIcon>
                            </ListItem>
                          )}
                        </Draggable>
                      ))}

                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
            </Grid>
          </Grid>
        }
      </DialogContent>
      <DialogActions>
        <ColoredButton color="success" onClick={handleSubmit}>
          Зачувај
        </ColoredButton>

        <ColoredButton color="error" onClick={onClose}>
          Затвори
        </ColoredButton>
      </DialogActions>
    </Dialog>
  );
};

export default GeneratePackageDialog;
